// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bey_a bhu_bk bhu_bl bhu_bo","SwipeLeftToClose--animating":"bey_b"};